import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  usersComponentWrapper: {},
  statusBadge: {
    background: "#FEE4E2 !important",
    border: "1px solid #E0E2E7",
    padding: "3px 10px",
    borderRadius: 20,
    height: 32,
    fontWeight: 600,
    fontSize: 10,
    lineHeight: "20px",
    color: "#F97066 !important",
  },
  statusBadgeActive: {
    background: "#D1FADF !important",
    border: "1px solid #D1FADF",
    color: "#32D583 !important",
  },
  statusBadgeInvitationSent: {
    background: "#FEF0C7 !important",
    border: "1px solid #FEF0C7",
    color: "#F79009 !important",
  },
  statusBadgeRejected: {
    background: "#FECDCA !important",
    border: "1px solid #FECDCA",
    color: "#F04438 !important",
  },
  button: {
    cursor: "pointer",
  },
  iconButtonStyles: {
    paddingLeft: 0,
    paddingRight: 1,
    color: "#475467",
    "& a": {
      color: "#475467",
    },
    "&:hover": {
      background: "transparent",
    },
  },
  changeButtonStatus: {
    whiteSpace: "nowrap",
    "& span > div": {
      display: "flex",
      alignItems: "center",
    },
  },
  revokeModal: {
    width: "520px !important",
  },
  descriptionRevokeModal: {
    color: "#232325",
  },
  subDescriptionRevokeModal: {
    color: "#004D95",
  },
  textModal: {
    fontFamily: "Manrope",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.05px",
  },
}));

export default styles;
